module.exports = __webpack_public_path__ + "media/icons/linkedin-e918cfd4.png";